<template>
  <div class="delivery-block">
    <b-form-group label="Transportzweck" label-cols="12" label-cols-md="4" v-if="context.toLowerCase() === 'piglet'">
      <b-input type="text" :value="context.toLowerCase() === 'piglet' ? 'Nutzung' : 'Schlachtung'" disabled/>
    </b-form-group>

    <b-form-group label="KFZ (Zugmaschine):" label-cols="12" label-cols-md="4">
      <app-select
        v-model="data.transporterId"
        allow-text-value
        :text-value="data.transporter"
        @changeText="text => data.transporter = text"
        text-value-label="Kennzeichen..."
        text-value-placeholder="Kennzeichen angeben"
        :options="transporterOptions"
        :disabled="disabled || saving"/>
    </b-form-group>

    <b-form-group label="KFZ (Hänger):" label-cols="12" label-cols-md="4">
      <app-select
        v-model="data.secondTransporterId"
        allow-text-value
        :text-value="data.secondTransporter"
        @changeText="text => data.secondTransporter = text"
        text-value-label="Kennzeichen..."
        text-value-placeholder="Kennzeichen angeben"
        :options="transporterOptions"
        :disabled="disabled || saving"/>
    </b-form-group>



    <b-form-group label="Entladeort:" label-cols="12" label-cols-md="4">
      <b-textarea v-model="data.dischargeTransport" rows="3"
                  :disabled="disabled || saving"/>
    </b-form-group>

    <b-form-group label="Vorauss. Beförderungszeit (h):" label-cols="12" label-cols-md="6">
      <b-input type="number" v-model="carriageDuration" :disabled="disabled || saving" min="0" step=".1"/>
    </b-form-group>
  </div>
</template>

<script>
import {computed, ref, watch} from '@vue/composition-api'
import ModalSelectFactory from "@/app/components/delivery/ModalSelectFactory.vue";
import AppSelect from "@/app/components/general/AppSelect.vue";

const parseDuration = str => {
  const [h, m] = str.split(':')
  const minutes = (parseInt(h) * 60) + parseInt(m)
  return minutes / 60
}

export default {
  components: {AppSelect, ModalSelectFactory},
  props: {
    value: { type: Object, required: true },
    context: { type: String, required: true },
    disabled: { type: Boolean, required: true },
    saving: { type: Boolean, required: true },
  },

  setup(props, { emit }) {
    const store = window.useStore()
    const slaughterHouses = computed(() => store.state.pwa.deliveries.piglet.config.slaughterHouse);

    const data = ref(props.value)
    const carriageDuration = ref(0)

    if (typeof data.value.carriageDuration !== 'undefined' && data.value.carriageDuration && data.value.carriageDuration.includes(':')) {
      carriageDuration.value = parseDuration(data.value.carriageDuration)
    }

    watch(data, () => {
      const slaughterHouse = slaughterHouses.value.data.find(d => d.id === data.value.slaughterHouseId);
      if(slaughterHouse && slaughterHouse.name)
        data.value.dischargeTransport = [
          slaughterHouse.street,
          slaughterHouse.town,
          slaughterHouse.country
        ].join('\n');
      emit('change', data)
    }, { deep: true })

    watch(carriageDuration, (input) => {
      const minutes = input * 60
      const hours = Math.floor(minutes / 60)
      const rest = minutes % 60
      data.value.carriageDuration = [
        ('0' + hours).substr(-2),
        ('0' + rest).substr(-2),
      ].join(':')
    })

    const transportsForDischarge = computed(() => store.state.pwa.deliveries.piglet.config.transport.data
      .filter(t => [1, 5, 6].includes(t.id))
      .map(t => ({
        text: t.name,
        value: t.id,
      })))

    const transporterOptions = computed(() => store.state.pwa.deliveries.piglet.config.transporter.data
      .map(t => ({
        text: t.licensePlate,
        value: t.id,
      }))
    )

    return {
      data,
      carriageDuration,
      transporterOptions,
      transportsForDischarge,
    }
  }
}
</script>
